import { createAction } from "@ngrx/store";

export const logOut = createAction("[App Component] Log Out");
